<!--
 * @Author: yangxu yangxu@staff.hexun.com
 * @Date: 2025-02-14 09:15:11
 * @LastEditors: yangxu yangxu@staff.hexun.com
 * @LastEditTime: 2026-05-21 17:51:48
 * @FilePath: /js_celue-zuhe_src/src/components/CombinationPosition.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <ul class="position" :class="{ 'has-lhjx': lhjx_config }">
    <li class="position-table" v-if="holds && holds.length > 0">
      <div class="position-scroll" :class="{ 'is-scroll': lhjx_config }">
        <!-- Header Row -->
        <div class="position-header">
          <div class="pos-left">市值</div>
          <div class="pos-right">
            <div class="item-col">盈亏</div>
            <div class="item-col">持仓/仓位</div>
            <div class="item-col">成本/现价</div>
            <div class="item-col" v-if="lhjx_config">选股依据</div>
          </div>
        </div>
        <!-- Data Rows -->
        <div v-for="(item, index) in holds" :key="index" class="position-row">
          <div class="pos-left">
            <div class="stock-name">{{ item.stock_name || "--" }}</div>
            <div class="market-value">
              {{ item.market_value.toFixed(2) || "--" }}
            </div>
          </div>
          <div class="pos-right">
            <div
              class="item-col"
              :class="{
                red: fdyk[index] > 0,
                green: fdyk[index] < 0,
                black: fdyk[index] == 0,
              }"
            >
              <div>
                {{
                  fdyk[index]
                    ? `${fdyk[index] > 0 ? "+" : ""} ${fdyk[index].toFixed(2)}`
                    : "--"
                }}
              </div>
              <div>
                {{
                  fdyk[index]
                    ? `${fdyk[index] > 0 ? "+" : ""} ${
                        fdyk[index] == 0
                          ? 0
                          : (
                              (item.last_price / item.hold_cost_price - 1) *
                              100
                            ).toFixed(2)
                      }%`
                    : "--"
                }}
              </div>
            </div>
            <div class="item-col">
              <div>{{ item.hold_amount || "--" }}</div>
              <div>
                {{
                  list.fund.assets
                    ? `${((item.market_value / list.fund.assets) * 100).toFixed(
                        2,
                      )}%`
                    : "--"
                }}
              </div>
            </div>
            <div class="item-col">
              <div>{{ (item.hold_cost_price * 1).toFixed(2) || "--" }}</div>
              <div>{{ Number(item.last_price).toFixed(2) || "--" }}</div>
            </div>
            <div class="item-col" v-if="lhjx_config">
              <img
                class="basis-btn"
                src="@/assets/img/reportInfo.png"
                @click="handleBasisClick(item)"
              />
            </div>
          </div>
        </div>
      </div>
    </li>
    <Empty v-else />
  </ul>
</template>
<script setup>
// 导入 Empty 组件
import Empty from "./Empty.vue";
// 从 Vue 中导入 ref 和 watchEffect 钩子
import { ref, watchEffect } from "vue";

// 从 Vuex 中导入 useStore 函数
import { useStore } from "vuex";
// 创建 Vuex store 实例
const store = useStore();
// 定义一个响应式的数组变量，用于存储持仓数据
const holds = ref([]);
// 定义一个响应式的数组变量，用于存储盈亏数据
const fdyk = ref([]);
// 定义一个响应式的对象变量，用于存储详细数据
const list = ref({});
//
const lhjx_config = ref(false);

// 点击"依据"按钮，调用研报用户端弹窗
const handleBasisClick = (item) => {
  window.httpToHttps.stockReport
    .reportBasisUser({
      stockId: item.stock_id,
      stockName: item.stock_name,
      stockCode: item.stock_code,
      type: "3",
      id: item.basis_id,
    })
    .then((result) => {
      console.log("用户端研报依据弹窗结果:", result);
    });
};

// 使用 watchEffect 监听 store 中的状态变化
watchEffect(() => {
  //NOSONAR
  // 打印当前的 holds 数据
  console.log("store.state.detail", store.state.detail.holds);
  // 将 store 中的持仓数据赋值给 holds
  holds.value = store.state.detail.holds;
  // 将 store 中的盈亏数据赋值给 fdyk
  fdyk.value = store.state.fdyk;
  // 将 store 中的详细数据赋值给 list
  list.value = store.state.detail;
  lhjx_config.value = store.state.detail.product.lhjx_config;
});
</script>
<style lang="scss">
.position {
  background: #fff;
  border-radius: calc(
    var(--imgfontSize) * 20
  ); /* 10px -> calc(var(--imgfontSize) * 20) */
  padding: calc(var(--imgfontSize) * 40) calc(var(--imgfontSize) * 24); /* 20px, 12px -> calc(var(--imgfontSize) * 40), calc(var(--imgfontSize) * 24) */

  .position-table {
    .position-scroll {
      &.is-scroll {
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
      }
    }
  }

  /* Header row */
  .position-header {
    display: flex;
    align-items: stretch;
    font-size: calc(
      var(--imgfontSize) * 24
    ); /* 12px -> calc(var(--imgfontSize) * 24) */
    font-weight: 400;
    color: #666;
    line-height: calc(
      var(--imgfontSize) * 24
    ); /* 12px -> calc(var(--imgfontSize) * 24) */
    letter-spacing: 0;
    padding: 0 0 calc(var(--imgfontSize) * 6); /* 3px -> calc(var(--imgfontSize) * 6) */

    .pos-left {
      flex-shrink: 0;
      width: calc(
        var(--imgfontSize) * 170
      ); /* 85px -> calc(var(--imgfontSize) * 170) */
    }

    .pos-right {
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-shrink: 0;
      text-align: right;

      .item-col {
        flex-shrink: 0;
      }
      .item-col:nth-child(1) {
        width: calc(var(--imgfontSize) * 220);
      }
      .item-col:nth-child(2) {
        width: calc(var(--imgfontSize) * 120);
      }
      .item-col:nth-child(3) {
        width: calc(var(--imgfontSize) * 140);
      }
      .item-col:nth-child(4) {
        width: calc(var(--imgfontSize) * 120);
        text-align: center;
      }
    }
  }

  /* Data rows */
  .position-row {
    display: flex;
    align-items: stretch;
    padding: calc(var(--imgfontSize) * 24) 0; /* 12px -> calc(var(--imgfontSize) * 24) */
    line-height: calc(
      var(--imgfontSize) * 36
    ); /* 18px -> calc(var(--imgfontSize) * 36) */
    border-bottom: 1px solid #f0f0f0;
    font-size: calc(var(--imgfontSize) * 32);
    font-weight: 600;
    &:last-child {
      border-bottom: none;
    }

    .pos-left {
      flex-shrink: 0;
      width: calc(
        var(--imgfontSize) * 170
      ); /* 85px -> calc(var(--imgfontSize) * 170) */
      text-align: left;

      .stock-name {
        letter-spacing: 0;
        margin-bottom: calc(
          var(--imgfontSize) * 6
        ); /* 3px -> calc(var(--imgfontSize) * 6) */
        font-size: calc(
          var(--imgfontSize) * 32
        ); /* 16px -> calc(var(--imgfontSize) * 32) */
        font-weight: 700;
        color: #111;
      }

      .market-value {
        font-size: calc(
          var(--imgfontSize) * 28
        ); /* 14px -> calc(var(--imgfontSize) * 28) */
        font-weight: 400;
        color: #999;
      }
    }

    .pos-right {
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-shrink: 0;
      text-align: right;

      .item-col {
        flex-shrink: 0;
      }
      .item-col:nth-child(1) {
        width: calc(var(--imgfontSize) * 220);
      }
      .item-col:nth-child(2) {
        width: calc(var(--imgfontSize) * 120);
      }
      .item-col:nth-child(3) {
        width: calc(var(--imgfontSize) * 140);
      }
      .item-col:nth-child(4) {
        width: calc(var(--imgfontSize) * 120);
        text-align: center;
      }

      > .item-col > div:nth-child(1) {
        margin-bottom: calc(
          var(--imgfontSize) * 6
        ); /* 3px -> calc(var(--imgfontSize) * 6) */
      }
    }
  }

  &.has-lhjx {
    .position-row .item-col .basis-btn {
      width: calc(var(--imgfontSize) * 40);
      height: calc(var(--imgfontSize) * 40);
      vertical-align: middle;
      cursor: pointer;
    }
  }
}

.van-divider {
  --van-divider-margin: 0;
}
</style>
